import { createFileRoute, redirect } from "@tanstack/react-router";
import AdminPendingPage from "@/pages/admin/pending";

export const Route = createFileRoute("/app/admin/pending")({
  beforeLoad: ({ location }) => {
    // Redirect /app/admin/pending to /app/admin/pending/invites
    if (location.pathname === "/app/admin/pending") {
      throw redirect({ to: "/app/admin/pending/invites" });
    }
  },
  component: AdminPendingPage,
});
